import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { injectIntl } from "react-intl";
import IntlMessages from "../../../helpers/IntlMessages";

export default injectIntl((props) => {
  const { dataFailed, dataSuccess, isFailedTable = false, intl } = props;
  const [state, setState] = useState({
    columns: [],
  });

  useEffect(() => {
    // Tạo danh sách cột cơ bản
    let baseColumns = [
      {
        Header: <IntlMessages id="stock.name" />,
        accessor: "name",
        minWidth: 150,
      },
      {
        Header: <IntlMessages id="stock.unit" />,
        accessor: "unit",
      },
      {
        Header: <IntlMessages id="warehouse.import-price" />,
        accessor: "price_new",
      },
      {
        Header: <IntlMessages id="warehouse.import-quantity" />,
        accessor: "count",
      },
      {
        Header: <IntlMessages id="stock.inventory" />,
        accessor: "inventory",
      },
      {
        Header: <IntlMessages id="stock.total-import" />,
        accessor: "total",
      },
    ];

    // Nếu đây là bảng lỗi, thêm một cột "Lý do lỗi"
    if (isFailedTable) {
      baseColumns.push({
        Header: <IntlMessages id="table.import.error_reason" />,
        accessor: "_errorMessage", // Lấy từ dữ liệu đã chuẩn bị
        minWidth: 200,
        // Thêm style cho cột này để nổi bật
        style: {
          fontWeight: "bold",
          whiteSpace: "pre-wrap", // Để xuống dòng nếu lỗi quá dài
        },
      });
    }

    setState({
      columns: [
        {
          Header: (
            <div
              style={{ textAlign: "center", color: "red", fontWeight: "bold" }}
            >
              <IntlMessages id="table.import.failed" />: {dataFailed.length}
              <span
                style={{
                  textAlign: "center",
                  color: "blue",
                  fontWeight: "bold",
                }}
              >
                {" "}
                - <IntlMessages id="table.import.success" />:{" "}
                {dataSuccess.length}{" "}
              </span>
            </div>
          ),
          columns: baseColumns,
        },
      ],
    });
  }, [isFailedTable]); // Thêm isFailedTable vào dependency array

  const getTrProps = (state, rowInfo, column) => {
    // Chỉ áp dụng style đỏ nếu đây là bảng lỗi
    if (isFailedTable) {
      return {
        style: {
          color: "red",
          backgroundColor: "#fff0f0",
        },
      };
    }
    return {};
  };

  return (
    <ReactTable
      data={dataFailed}
      columns={state.columns}
      getTrProps={getTrProps}
      defaultPageSize={10}
      minRows={0}
      showPageJump={false}
      showPageSizeOptions={true}
      PaginationComponent={Pagination}
      NoDataComponent={() => null}
    />
  );
});
